import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['code', 'panel', 'overlay']

  declare readonly codeTarget: HTMLDivElement
  declare readonly panelTarget: HTMLDivElement
  declare readonly overlayTarget: HTMLDivElement

  expanded = false
  maxHeight = 288

  connect (): void {
    this.checkHeight()
  }

  checkHeight (): void {
    const height = this.codeTarget.scrollHeight

    if (height > this.maxHeight) {
      this.codeTarget.classList.add('max-h-72')
      this.panelTarget.classList.remove('hidden')
      const link = this.panelTarget.querySelector('a')
      if (link !== null) link.textContent = 'Show all'
      this.overlayTarget.classList.remove('hidden')
      this.expanded = false
    } else {
      this.panelTarget.classList.add('hidden')
      this.overlayTarget.classList.add('hidden')
    }
  }

  expand (): void {
    this.expanded = !this.expanded

    const link = this.panelTarget.querySelector('a')
    if (link === null) return

    if (this.expanded) {
      this.codeTarget.classList.remove('max-h-72')
      link.textContent = 'Show less'
      this.overlayTarget.classList.add('hidden')
    } else {
      this.codeTarget.classList.add('max-h-72')
      link.textContent = 'Show all'
      this.overlayTarget.classList.remove('hidden')
    }
  }
}
